module.exports = __webpack_public_path__ + "static/media/shape3.71f789f7.svg";